import { useState, useEffect, useMemo } from "react";
import { timestampToCompactDateTime } from "../common/common.date";

export function useCurrentAppVersion() {
	const [buildDate, setBuildDate] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;
		fetch("/meta.json")
			.then((res) => res.json())
			.then((meta) => {
				if (!cancelled && meta.buildDate) {
					setBuildDate(meta.buildDate);
				}
			})
			.catch(() => {
				if (!cancelled) setBuildDate(null);
			});

		return () => {
			cancelled = true;
		};
	}, []);

	const memoizedBuildDate = useMemo(() => {
		if (buildDate) {
			return timestampToCompactDateTime(buildDate);
		}

		return null;
	}, [buildDate]);

	return { buildDate: memoizedBuildDate };
}
